import gql from 'graphql-tag';

export default gql`
  mutation sendMail(
    $name: String
    $email: String
    $subject_id: Int
    $message: String
  ) {
    createRequest(
      input: {
        name: $name
        email: $email
        subject_id: $subject_id
        message: $message
      }
    )
  }
`;
